import { CheckOutlined } from "@ant-design/icons"
import { Avatar, Card, Flex, Tag, Tooltip, Typography } from "antd"

import { empty } from "../../../../../../../constants/placeholders"
import type { AlbumListItem } from "../../../../../../Album/types/album.types.ts"

const { Text, Paragraph } = Typography

interface AlbumCardProps {
  album: AlbumListItem
  isSelected: boolean
  onClick: (id: string) => void
}

export const AlbumSelectorCard = ({
  album,
  onClick,
  isSelected
}: AlbumCardProps) => {
  const isVisible = album?.is_visible_to_customer
  const count = album?.attachments_count || 0
  const created = album?.created

  return (
    <Card
      onClick={() => onClick(album.id)}
      hoverable
      className={`h-full relative ${isSelected ? "ring-2 ring-primary" : ""}`}
      styles={{ body: { padding: 0 } }}
    >
      {isSelected && (
        <div className="absolute top-2 right-2 z-10 bg-primary rounded-full w-6 h-6 flex items-center justify-center">
          <CheckOutlined className="text-white text-xs" />
        </div>
      )}
      <Tooltip title={`${isVisible ? "Visible" : "Hidden"} for customer`}>
        <Tag
          color={isVisible ? "green" : "red"}
          className="m-0 absolute top-2 right-2"
        >
          {isVisible ? "Visible" : "Hidden"}
        </Tag>
      </Tooltip>

      <div className="p-2.5">
        <Flex justify="space-between" align="start" className="mb-1">
          <Text ellipsis={{ tooltip: album?.name }} strong className="block">
            {album?.name}
          </Text>
        </Flex>

        <Paragraph
          ellipsis={{
            rows: 2,
            expandable: "collapsible",
            symbol: (expanded) => (expanded ? "less" : "more")
          }}
          type="secondary"
          className="block mb-1 text-sm"
        >
          {album?.description || empty}
        </Paragraph>

        <Flex align="center" gap={8} className="mb-3">
          <Text type="secondary" className="text-xs">
            {created}
          </Text>
          <Text type="secondary" className="text-xs">
            •
          </Text>
          <Text type="secondary" className="text-xs">
            {count} file(s)
          </Text>
        </Flex>

        <Flex justify="space-between" gap={3} align="center">
          {album?.created_by_name && (
            <Flex align="center" className={"overflow-hidden"} gap={8}>
              <Avatar className={"shrink-0"} size="small">
                {album?.created_by_name?.charAt(0)}
              </Avatar>
              <Text
                ellipsis={{ tooltip: album?.created_by_name }}
                type="secondary"
                className="text-sm"
              >
                {album?.created_by_name}
              </Text>
            </Flex>
          )}
        </Flex>
      </div>
    </Card>
  )
}
